module.exports = __webpack_public_path__ + "static/media/maintenance.b9a6db05.svg";